// extracted by mini-css-extract-plugin
module.exports = {"container":"BosSideBar_container__1iRtX","headingBox":"BosSideBar_headingBox__2Uc2u"};